import {
  Component,
  AfterViewInit,
  QueryList,
  ViewChildren,
  ElementRef
} from '@angular/core';

export interface NodeItem {
  id: string;
  x: number;
  y: number;
  label: string;
  icon: string;
}

interface LineDef {
  from: string;
  to: string;
  d: string;
}
declare const ResizeObserver: any;

@Component({
  selector: 'app-agent-diagram',
  templateUrl: './agent-diagram.component.html',
  styleUrls: ['./agent-diagram.component.scss']
})
export class AgentDiagramComponent implements AfterViewInit {

  @ViewChildren('nodeEl') nodeElements!: QueryList<ElementRef<HTMLElement>>;

  nodes: NodeItem[] = [
	{ id: 'aws',    label: 'aws s3',                    x: 40, y: 120, icon: 'bi bi-amazon' },
	{ id: 'google', label: 'google cloud storage',      x: 40, y: 260, icon: 'bi bi-google' },
	{ id: 'premise', label: 'on-premise server',        x: 40, y: 400, icon: 'bi bi-cloud-arrow-down' },

	{ id: 'integra', label: ' SR Integration Agent',   x: 250, y: 260, icon: 'sidebar-logo-styles' },
	{ id: 'contracts',  label: 'Contracts',            x: 460,  y: 120, icon: 'bi bi-file-earmark-text' },
	{ id: 'mortgage',   label: 'Mortgage',             x: 460,  y: 260, icon: 'bi bi-bank' },
	{ id: 'statements', label: 'Account Statements',   x: 460,  y: 400, icon: 'bi bi-journals' },

    { id: 'sr',   label: 'SR Extraction Agent',        x: 750, y: 120, icon: 'sidebar-logo-styles' },

    { id: 'ai',    label: 'SR AI Assistant',           x: 1050, y: 120, icon: 'sidebar-logo-styles ' },
    { id: 'store', label: 'Data Storing Agent',        x: 1050, y: 260, icon: 'sidebar-logo-styles ' },
    { id: 'integ', label: 'Data Integration Agent',    x: 1050, y: 400, icon: 'sidebar-logo-styles ' },

	{ id: 'sap',   label: 'SAP',                       x: 1350, y: 320, icon: 'icon icon-sap' },
    { id: 'jira',  label: 'JIRA',                      x: 1350, y: 420, icon: 'icon icon-jira' },
    { id: 'share', label: 'SharePoint',                x: 1350, y: 520, icon: 'icon icon-sharepoint' },
  ];

  /** Definición de qué nodos se conectan a cuáles */
  lineMapping = [
	{ from: 'aws',  to: 'integra' },
    { from: 'google',   to: 'integra' },
    { from: 'premise', to: 'integra' },
    { from: 'integra', to: 'contracts' },
    { from: 'integra', to: 'mortgage' },
    { from: 'integra', to: 'statements' },

    { from: 'contracts',  to: 'sr' },
    { from: 'mortgage',   to: 'sr' },
    { from: 'statements', to: 'sr' },

    { from: 'sr',   to: 'ai' },
    { from: 'sr',  to: 'store' },
    { from: 'sr', to: 'integ' },

	{ from: 'integ',   to: 'sap' },
    { from: 'integ',  to: 'jira' },
    { from: 'integ', to: 'share' }
  ];

  /** Paths SVG de las líneas */
  lines: LineDef[] = [];


  ngAfterViewInit(): void {
    setTimeout(() => {
      this.recalculateLines();
    });

    // Recalcular si un nodo cambia de tamaño
    this.nodeElements.forEach(el => {
      new ResizeObserver(() => this.recalculateLines())
        .observe(el.nativeElement);
    });
	const container = this.nodeElements.first?.nativeElement.parentElement;
    if (container) {
      container.addEventListener('scroll', () => {
        this.recalculateLines();
      });
    }
  }

  /** =======================
   *  CALCULAR LINEAS DINÁMICAS
   *  ======================= */
  recalculateLines() {
	 const nodesById: any = {};
  const container = this.nodeElements.first?.nativeElement.parentElement;

  if (!container) return;

  const containerRect = container.getBoundingClientRect();

  this.nodeElements.forEach((el) => {
    const id = el.nativeElement.getAttribute('data-id')!;
    const nodeRect = el.nativeElement.getBoundingClientRect();

    // Calcular posición relativa al contenedor, considerando el scroll
    const scrollLeft = container.scrollLeft || 0;
    const scrollTop = container.scrollTop || 0;

    nodesById[id] = {
      cx: (nodeRect.left - containerRect.left) + scrollLeft + (nodeRect.width / 2),
      cy: (nodeRect.top - containerRect.top) + scrollTop + (nodeRect.height / 2)
    };
  });

  this.lines = this.lineMapping.map(conn => {
    const A = nodesById[conn.from];
    const B = nodesById[conn.to];

    if (!A || !B) return { from: conn.from, to: conn.to, d: '' };

    // coordenadas relativas al contenedor (ya calculadas arriba)
    const x1 = A.cx;
    const y1 = A.cy;

    const x2 = B.cx;
    const y2 = B.cy;

    // curva suave
    const d = `M ${x1} ${y1} C ${(x1 + x2) / 2} ${y1}, ${(x1 + x2) / 2} ${y2}, ${x2} ${y2}`;

    return { from: conn.from, to: conn.to, d };
  });

  }

}